module.exports = __webpack_public_path__ + "img/slash-square-fill.c1bf7051.svg";